// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
import loader from '@monaco-editor/loader';
import { buildOpenSCADCompletionItemProvider } from './openscad-completions';
import openscadLanguage from './openscad-language';
import { NIGHT_OWL, nightOwlTheme } from './night-owl-theme';
// https://microsoft.github.io/monaco-editor/playground.html#extending-language-services-custom-languages
export async function registerOpenSCADLanguage(fs, workingDir, zipArchives) {
    const monaco = await loader.init();
    monaco.editor.defineTheme(NIGHT_OWL, nightOwlTheme);
    monaco.languages.register({
        id: 'openscad',
        extensions: ['.scad'],
        mimetypes: ["text/openscad"],
    });
    const { conf, language } = openscadLanguage;
    monaco.languages.setLanguageConfiguration('openscad', conf);
    monaco.languages.setMonarchTokensProvider('openscad', language);
    monaco.languages.registerCompletionItemProvider('openscad', await buildOpenSCADCompletionItemProvider(fs, workingDir, zipArchives));
}
